import Styles from './ToolTip.module.scss';
import React, { JSX } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { isTouchScreen, viewport } from '../../utils/utils';
import { AssetPathPropConfig } from '../../services/LineTableBasicPropConfig';

const ToolTip = ({ content, heading='', tooltipClass = '',isBenefit=false }: any): JSX.Element => {
  const viewPort = viewport();
  const touchDevice = isTouchScreen();
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();

  return (
    content && (
      <OverlayTrigger
        placement='auto'
        rootClose
        trigger={`${
          viewPort === 'mobile' || viewPort === 'tablet' || touchDevice ? 'click' : 'hover'
        }`}
        overlay={
          content && (
            <Popover id='popover-basic'>
              {heading !== '' && <Popover.Header>{heading}</Popover.Header>}
              <Popover.Body>{content}</Popover.Body>
            </Popover>
          )
        }
      >
        <div className={`${Styles.tooltipicon} ${tooltipClass} ${isBenefit && Styles.benefits}`}>
          {assetPath && <img src={`${assetPath}/icons/tooltip_icon.svg`} width={24} height={24} alt=''/>}
        </div>
      </OverlayTrigger>
    )
  );
};
export default ToolTip;
